import React, {createContext, FunctionComponent, useCallback, useContext, useEffect, useState} from 'react';

const INITIAL_STATE = {
    produkte: []
};

const LOCALSTORAGE_KEY = 'merkliste';

const MerklisteContext = createContext<MerklisteContextModel>({
    merkliste: INITIAL_STATE,
    deleteItem: () => undefined
});

interface MerklisteContextModel {
    merkliste: MerklisteModel;
    deleteItem: (itemToDelete: number) => void;
}

interface MerklisteModel {
    produkte?: Array<number>;
}

interface MerklisteContextProviderProps {
}

export const MerklisteContextProvider: FunctionComponent<MerklisteContextProviderProps> = ({children}) => {
    const [merkliste, setMerkliste] = useState<MerklisteModel>(INITIAL_STATE);

    const readFromLocalStorage = useCallback(() => {
        const serializedMerkliste = window.localStorage.getItem(LOCALSTORAGE_KEY);
        const merklisteFromLocalStorage = !!serializedMerkliste ? JSON.parse(serializedMerkliste) : INITIAL_STATE;
        setMerkliste(merklisteFromLocalStorage);
    }, [setMerkliste]);

    const deleteItem = useCallback((itemToDelete: number) => {
        const newMerkliste = {
            ...merkliste,
            produkte: merkliste.produkte?.filter(produktId => produktId !== itemToDelete) || []
        };
        window.localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(newMerkliste));
        // @ts-ignore
        window.Juris?.moduleRegistry._registeredModules.get('Bookmarks').instances.entries().next().value[1].updateCounter();
        setMerkliste(newMerkliste);
    }, [merkliste]);

    useEffect(readFromLocalStorage, [readFromLocalStorage]);

    return <MerklisteContext.Provider value={{merkliste, deleteItem}}>{children}</MerklisteContext.Provider>;
};

export const useMerklisteContext = () => {
    const context = useContext(MerklisteContext);
    if (context === undefined) {
        throw new Error('useMerklisteContext must be used within a MerklisteContextProvider');
    }
    return context;
};